// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7615":"css/app.6754","8695":"css/admin-app.6754"}[chunkId] + ".css";
};